import { render, staticRenderFns } from "./NineCellMatrix.vue?vue&type=template&id=b2b0eaca&"
import script from "./NineCellMatrix.vue?vue&type=script&lang=js&"
export * from "./NineCellMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports